import React from 'react';
import { BriefcaseBusiness, Gauge, GraduationCap } from 'lucide-react';

const ContextBadgePanel = ({ context = {} }) => {
  const badges = [
    { icon: BriefcaseBusiness, label: context.role || 'Career target' },
    { icon: Gauge, label: context.readiness || 'Readiness aware' },
    { icon: GraduationCap, label: context.progress || 'Progress synced' },
  ];

  return (
    <div className="flex flex-wrap gap-2">
      {badges.map(({ icon: Icon, label }) => (
        <span key={label} className="inline-flex items-center gap-1 rounded-md border border-white/10 bg-white/5 px-2 py-1 text-[11px] text-purple-100">
          <Icon size={12} aria-hidden="true" />
          {label}
        </span>
      ))}
    </div>
  );
};

export default ContextBadgePanel;
